"use strict";

exports.__esModule = true;
exports.getDefaultFontSize = exports.DEFAULT_HEADER_DESCRIPTION_FONT_SIZE = exports.DEFAULT_HEADER_TITLE_FONT_SIZE = exports.DEFAULT_TOP_NAVIGATION_FONT_SIZE = exports.POST_FONT_SIZES = exports.HEADER_FONT_SIZES = void 0;

var _headerSizes = require("./header-sizes");

var _layoutTypes = require("./layout-types");

var _HEADER_FONT_SIZES, _POST_FONT_SIZES;

var HEADER_FONT_SIZES = (_HEADER_FONT_SIZES = {}, _HEADER_FONT_SIZES[_headerSizes.HEADER_SIZE_100] = {
  title: {
    start: 20,
    min: 20,
    max: 26
  },
  description: {
    start: 12,
    min: 12,
    max: 14
  }
}, _HEADER_FONT_SIZES[_headerSizes.HEADER_SIZE_200] = {
  title: {
    start: 32,
    min: 32,
    max: 48
  },
  description: {
    start: 14,
    min: 14,
    max: 20
  }
}, _HEADER_FONT_SIZES[_headerSizes.HEADER_SIZE_300] = {
  title: {
    start: 48,
    min: 48,
    max: 56
  },
  description: {
    start: 16,
    min: 16,
    max: 22
  }
}, _HEADER_FONT_SIZES[_headerSizes.HEADER_SIZE_400] = {
  title: {
    start: 56,
    min: 56,
    max: 62
  },
  description: {
    start: 18,
    min: 18,
    max: 24
  }
}, _HEADER_FONT_SIZES[_headerSizes.HEADER_SIZE_500] = {
  title: {
    start: 62,
    min: 62,
    max: 72
  },
  description: {
    start: 24,
    min: 24,
    max: 32
  }
}, _HEADER_FONT_SIZES); // Posts

exports.HEADER_FONT_SIZES = HEADER_FONT_SIZES;
var POST_FONT_SIZES = (_POST_FONT_SIZES = {}, _POST_FONT_SIZES[_layoutTypes.LAYOUT_CARD_SMALL] = {
  title: {
    start: 22,
    min: 16,
    max: 22
  },
  description: {
    start: 16,
    min: 12,
    max: 16
  },
  metadata: {
    start: 12,
    min: 10,
    max: 14
  }
}, _POST_FONT_SIZES[_layoutTypes.LAYOUT_CARD_MEDIUM] = {
  title: {
    start: 26,
    min: 18,
    max: 28
  },
  description: {
    start: 16,
    min: 12,
    max: 16
  },
  metadata: {
    start: 12,
    min: 10,
    max: 14
  }
}, _POST_FONT_SIZES[_layoutTypes.LAYOUT_CARD_LARGE] = {
  title: {
    start: 28,
    min: 20,
    max: 28
  },
  description: {
    start: 16,
    min: 12,
    max: 16
  },
  metadata: {
    start: 12,
    min: 10,
    max: 14
  }
}, _POST_FONT_SIZES[_layoutTypes.LAYOUT_CARD_PROFILE] = {
  title: {
    start: 26
  },
  description: {
    start: 16
  },
  metadata: {
    start: 12
  }
}, _POST_FONT_SIZES[_layoutTypes.LAYOUT_FULL_POST] = {
  title: {
    start: 40
  },
  description: {
    start: 18
  },
  metadata: {
    start: 14
  }
}, _POST_FONT_SIZES[_layoutTypes.LAYOUT_MOBILE] = {
  title: {
    start: 22
  },
  description: {
    start: 16
  },
  metadata: {
    start: 12
  }
}, _POST_FONT_SIZES[_layoutTypes.LAYOUT_SIDE_BY_SIDE] = {
  title: {
    start: 28,
    min: 20,
    max: 28
  },
  description: {
    start: 16,
    min: 12,
    max: 16
  },
  metadata: {
    start: 12,
    min: 10,
    max: 14
  }
}, _POST_FONT_SIZES[_layoutTypes.LAYOUT_GRID] = {
  title: {
    start: 22,
    min: 16,
    max: 22
  },
  description: {
    start: 16,
    min: 12,
    max: 16
  },
  metadata: {
    start: 12,
    min: 10,
    max: 14
  }
}, _POST_FONT_SIZES[_layoutTypes.LAYOUT_TEXT_ON_IMAGE_SMALL] = {
  title: {
    start: 22,
    min: 16,
    max: 22
  },
  description: {
    start: 16
  },
  metadata: {
    start: 12
  }
}, _POST_FONT_SIZES[_layoutTypes.LAYOUT_TEXT_ON_IMAGE_MEDIUM] = {
  title: {
    start: 36,
    min: 26,
    max: 48
  },
  description: {
    start: 16
  },
  metadata: {
    start: 12
  }
}, _POST_FONT_SIZES[_layoutTypes.LAYOUT_ONE_COLUMN_MOBILE] = {
  title: {
    start: 22
  },
  description: {
    start: 14
  },
  metadata: {
    start: 12
  }
}, _POST_FONT_SIZES[_layoutTypes.LAYOUT_SIDE_BY_SIDE_MOBILE] = {
  title: {
    start: 16
  },
  description: {
    start: 14
  },
  metadata: {
    start: 12
  }
}, _POST_FONT_SIZES[_layoutTypes.LAYOUT_TEXT_ON_IMAGE_MOBILE] = {
  title: {
    start: 22,
    min: 12,
    max: 30
  },
  description: {
    start: 16
  },
  metadata: {
    start: 12
  }
}, _POST_FONT_SIZES[_layoutTypes.LAYOUT_PG_TEXT_ON_IMAGE_MEDIUM] = {
  title: {
    start: 36,
    min: 26,
    max: 48
  },
  description: {
    start: 16
  },
  metadata: {
    start: 12
  }
}, _POST_FONT_SIZES[_layoutTypes.LAYOUT_PG_CARD_MEDIUM] = {
  title: {
    start: 26,
    min: 18,
    max: 28
  },
  description: {
    start: 16,
    min: 12,
    max: 16
  },
  metadata: {
    start: 12,
    min: 10,
    max: 14
  }
}, _POST_FONT_SIZES[_layoutTypes.LAYOUT_PG_SIDE_BY_SIDE] = {
  title: {
    start: 28,
    min: 20,
    max: 28
  },
  description: {
    start: 16,
    min: 12,
    max: 16
  },
  metadata: {
    start: 12,
    min: 10,
    max: 14
  }
}, _POST_FONT_SIZES[_layoutTypes.LAYOUT_PG_GRID] = {
  title: {
    start: 36,
    min: 26,
    max: 48
  },
  description: {
    start: 16
  },
  metadata: {
    start: 12
  }
}, _POST_FONT_SIZES);
exports.POST_FONT_SIZES = POST_FONT_SIZES;
var DEFAULT_TOP_NAVIGATION_FONT_SIZE = 14; // @TODO: remove the below, should use the HEADER_FONT_SIZES or POST_FONT_SIZES instead in index.ejs

exports.DEFAULT_TOP_NAVIGATION_FONT_SIZE = DEFAULT_TOP_NAVIGATION_FONT_SIZE;
var DEFAULT_HEADER_TITLE_FONT_SIZE = 40;
exports.DEFAULT_HEADER_TITLE_FONT_SIZE = DEFAULT_HEADER_TITLE_FONT_SIZE;
var DEFAULT_HEADER_DESCRIPTION_FONT_SIZE = 18;
exports.DEFAULT_HEADER_DESCRIPTION_FONT_SIZE = DEFAULT_HEADER_DESCRIPTION_FONT_SIZE;

var getDefaultFontSize = function getDefaultFontSize(layoutType, contentType) {
  return POST_FONT_SIZES[layoutType][contentType].start;
};

exports.getDefaultFontSize = getDefaultFontSize;